module.exports = __webpack_public_path__ + "img/arrow_3_color.f803c48f.svg";